import { fromJS, Map, OrderedMap, Set, List } from 'immutable'

import {
  NEW_TASK,
  TASK_TYPE,
  ROW_NUMBER,
  END_TASK,
  LOG_OUT,
  LOG_IN,
  CLEAR_ENTRIES,
  CHANGE_GH,
} from '../actions'

const initialState = Map({
  taskSuggestions: Set(['clip', 'prune', 'deleaf']),
  tasks: OrderedMap(),
  user: null,
  userSuggestions: Set(),
})

const reduce = (state = initialState, action) => {
  switch (action.type) {
    case NEW_TASK:
      return state
        .set(
          'tasks',
          state.get('tasks').map((task, id) => {
            return task.set('endDate', task.get('endDate') || Date.now())
          }),
        )
        .setIn(
          ['tasks', action.id],
          fromJS({
            id: action.id,
            startDate: action.startDate,
            type: List(),
          }),
        )
    case TASK_TYPE:
      return state
        .setIn(
          ['tasks', action.task, 'type'],
          List(action.newTypes || undefined),
        )
        .set(
          'taskSuggestions',
          state.get('taskSuggestions').concat(action.newTypes),
        )
    case ROW_NUMBER:
      return state.setIn(['tasks', action.task, 'row'], action.rowNumber)
    case CHANGE_GH:
      return state.setIn(
        ['tasks', action.task, 'greenhouse'],
        action.greenhouse,
      )
    case END_TASK:
      return state.setIn(['tasks', action.task, 'endDate'], action.endDate)
    case LOG_IN:
      return state
        .set('user', action.user)
        .set('userSuggestions', state.get('userSuggestions').add(action.user))
    case LOG_OUT:
      return state.set('user', null).set('tasks', OrderedMap())
    case CLEAR_ENTRIES:
      return state.set('tasks', OrderedMap())
    default:
      return state
  }
}

export default reduce



// WEBPACK FOOTER //
// ./src/model/reducers/data.js